<div class="low-res-container">
  <div class="card-body">
    <img src="assets/images/low-res.svg" width="215" height="96" alt="image" />
    <h3>Low Resolution Alert!</h3>
    <p>
      For best results, we recommend using a screen size of 1140 x 768 px or
      above. Therefore, Laptop and Desktop are the best compatible devices.
    </p>
    <div class="btn-wrap">
      <button mat-stroked-button >Okay</button>
      <button mat-raised-button color="primary">Desktop Version</button>
    </div>
  </div>
</div>
